import React, { useContext, useEffect, useState } from 'react';
import useFetch from 'use-http';
import { AppContext } from 'src/providers/AppContextProvider';
import { IAppContextState } from 'src/reducers/AppContext';

import { FormContainer, FormError, FormRow, FormSection, TextInput } from 'src/components/controls/forms/reactHookForm';

import { FormProvider, useForm } from 'react-hook-form';
import IOwner from 'src/models/IOwner';
import { DialogActionBar } from 'src/components/common/Dialog.redesign';
import Button from 'src/components/controls/forms/redesign/FormButton';
import { CreateOwnerAction } from './CreateOwner';
import { UseFormMethods } from 'react-hook-form';
import { AnyObject } from 'react-final-form';
import PhoneNumber from 'src/models/PhoneNumber';
import OwnerJointTenant from 'src/models/tract_detail/add_ownership_revised/OwnerJointTenant';
import USPSCityState from 'src/models/USPSCityState';
import { SelectItem } from 'src/models/common/SelectItem';
import PhoneNumberType from 'src/models/PhoneNumberType';
import AddressData from 'src/components/controls/forms/composite/AddressData';
import PhoneNumberData from 'src/components/controls/forms/composite/PhoneNumberData';

interface ICreateJointTenantProps {
    className?: string;
    states?: Array<SelectItem>;
    style?: React.CSSProperties;
    onOwnerCreated: (owner: IOwner) => void;
    actions: CreateOwnerAction[];
    phoneNumberTypes?: PhoneNumberType[];
}

const CreateJointTenant: React.FC<ICreateJointTenantProps> = (props) => {
    const appContext = useContext<IAppContextState>(AppContext);
    const [uspsData, setUspsData] = useState<USPSCityState>(undefined);
    const [stateValue, setStateValue] = useState<string | number>(undefined);
    const { post, response, error, get } = useFetch();
    const methods = useForm();

    // Effect to update the State and City after zipcode has been entered
    useEffect(() => {
        if (!!uspsData) {
            let uspsState: string = uspsData?.zipCode?.state;
            let uspsCity: string = uspsData?.zipCode?.city;

            updateCityState(uspsState, uspsCity);
        }
    }, [uspsData]);

    const updateCityState = (state: string, city: string) => {
        let stateId = !!props?.states ? props?.states.find((s) => s.name === state)?.id : undefined;

        if (!!stateId && !!city) {
            methods.setValue('address.state.id', stateId);
            methods.setValue('address.city', city);
            setStateValue(stateId);
        }
    };

    const getCityState = async (zipCode: string) => {
        const result = await get(`v1.0/usps/${zipCode}/local-source`);

        if (response.ok) {
            setUspsData(result);
        }
    };

    const onSubmit = async (data: AnyObject) => {
        let phoneNumberChanges: string = 'phoneNumberChanges';
        let phoneNumberAdds: string = 'phoneNumberAdds';
        let phoneNumberUpdates: string = 'phoneNumberUpdates';

        if (!!data[phoneNumberChanges]) {
            let updates: PhoneNumber[] = data[phoneNumberChanges][phoneNumberAdds];
            data[phoneNumberChanges][phoneNumberUpdates] = updates;
        }

        console.log('this is the data for the joint tenant owner, ', data as OwnerJointTenant);

        const result = await post(
            `/v1.0/clients/${appContext.clientNumber}/projects/${appContext.projectNumber}/owners/joint-tenant`,
            data as OwnerJointTenant
        );

        if (response.ok && !isNaN(result)) {
            data.id = parseInt(result, 10);
            data.ownerType = 'Joint-Tenant';
            props.onOwnerCreated(data as IOwner);
        }
    };

    const actions = (formMethods: UseFormMethods) => {
        const { isDirty, isSubmitting, isSubmitted, isValid } = methods.formState;

        if (props.actions && props.actions.length > 0) {
            return props.actions.map((a: CreateOwnerAction) => {
                if (a.isSave) {
                    return (
                        <Button
                            key={a.id}
                            disabled={isSubmitting || (isSubmitted && !isValid) || !isDirty}
                            intent={a.intent}
                            text={a.text}
                            onClick={() => formMethods.handleSubmit(onSubmit)()}
                        />
                    );
                } else {
                    return <Button key={a.id} intent={a.intent} text={a.text} onClick={a.action} />;
                }
            });
        }
        return <></>;
    };

    console.log(methods.errors);

    return (
        <>
            <FormError error={error} message="Unexpected error while saving owner." />
            <div className={props.className} style={props.style}>
                <FormProvider {...methods}>
                    <form onSubmit={methods.handleSubmit(onSubmit)}>
                        <FormContainer>
                            <FormSection title="Joint Tenant Details">
                                <FormRow>
                                    <TextInput isRequired={true} label="Joint Tenant Owner Group" name={'name'} style={{ width: '100%' }} />
                                    <TextInput name="ssnTaxId" label="Tax Id" className="lh-fifth-width" />
                                </FormRow>
                            </FormSection>
                            <FormSection title="Address">
                                <AddressData namePrefix="address." states={props.states} getCityState={getCityState} stateValue={stateValue} />
                            </FormSection>
                            <FormSection title="Phone Number">
                                <PhoneNumberData phoneTypes={props?.phoneNumberTypes} />
                            </FormSection>
                            {/* <div className="selected-owner-type">
                                <div>
                                    {this.state.tenantOwners.length > 0 && (
                                        <>
                                            <div style={{ fontSize: '2rem', marginBottom: '1rem' }}>Tenant Owners</div>
                                            {this.jointTenantOwners()}
                                        </>
                                    )}
                                </div>
                            </div> */}
                        </FormContainer>
                    </form>
                </FormProvider>
            </div>
            <DialogActionBar>{actions(methods)}</DialogActionBar>
        </>
    );
};

export default CreateJointTenant;



// WEBPACK FOOTER //
// ./src/components/project/sections/owners/createOwner/CreateJointTenant.tsx